import { observer } from "mobx-react-lite"
import { FC } from "react"

import styles from "../../../styles/Subpage.module.scss"

const Reviews: FC = () => {
  return (
    <>
      <div className={styles.subpage}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2><strong>Отзывы</strong> - узнайте что думают гости о нас!</h2>
              
              <iframe id="tlFrame0.8520103744736751" name="tlFrame0.8520103744736751" frameBorder="0" width="100%" height="1976" scrolling="no" style={{maxWidth: "none", minWidth: "100%"}} src="https://ru-ibe.tlintegration.ru/reviews-widget/index.default.html?int=true&amp;origin=http%3A%2F%2Flocalhost:3000&amp;conId=019615164705881316"></iframe>
              
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default observer(Reviews)